import clsx from 'clsx';
import React, { memo } from 'react';
import { getVigboUrl } from 'reactApp/modules/vigbo/vigbo.helpers';

import styles from './VigboLicenceNote.css';

export interface VigboLicenceNoteProps {
    className?: string;
}

export const VigboLicenceNote = memo(function VigboLicenceNote({ className }: VigboLicenceNoteProps) {
    return (
        <span className={clsx(styles.root, className)}>
            Связывая аккаунты, вы&nbsp;принимаете условия{' '}
            <a className={styles.link} target="_black" href={getVigboUrl('vigboRules')}>
                пользовательского&nbsp;соглашения
            </a>{' '}
            сервиса Vigbo
        </span>
    );
});
